// ----------------------------------------------------------------------------
// Chat bot
// ----------------------------------------------------------------------------
import Url from "@/constants/url-const";

export default {
  //ウィンドウ表示位置計算
  chatOpen() {
    var wH = 800;
    var wW = 500;
    var wT = this.chat_calT("DISP", "RB", wH); // 右下 Top
    var wL = this.chat_calL("DISP", "RB", wW); // 右下 Left
    var wOption =
      "top=" +
      wT +
      ", left=" +
      wL +
      ", height=" +
      wH +
      ", width=" +
      wW +
      ", menubar=no" +
      ", toolbar=no" +
      ", location=no" +
      ", status=no" +
      ", resizable=no" +
      ", directories=no";

    // 画面を開く
    var winObj = window.open(Url.LINK_CHAT_BOT, "_blank", wOption);
    winObj.focus();

    try {
      winObj.resizeTo(wW, wH);
      winObj.moveTo(wL, wT);
    } catch (e) {
      // do nothing
    }

    winObj = null;
  },

  // 開始縦位置を計算
  chat_calT(argDispOrHtml, argPos, argHeight) {
    var wBaseT = 0;
    if (argDispOrHtml == "HTML") {
      wBaseT = document.body.scrollTop;
      if (!wBaseT) {
        wBaseT = 0;
      }
    }
    var wH =
      argDispOrHtml == "HTML"
        ? document.documentElement.clientHeight
        : screen.availHeight;
    if (!wH) {
      wH = 0;
    }
    var wTop = 0;
    switch (argPos) {
      case "CC":
        wTop = Math.floor((wH - argHeight) / 2) + wBaseT;
        break;
      case "LT":
        wTop = wBaseT;
        break;
      case "RT":
        wTop = wBaseT;
        break;
      case "RB":
        wTop = Math.floor(wH - argHeight) + wBaseT;
        break;
      case "LB":
        wTop = Math.floor(wH - argHeight) + wBaseT;
        break;
    }
    if (wTop < 0) {
      return 0;
    } else {
      return wTop;
    }
  },

  // 開始横位置を計算
  chat_calL(argDispOrHtml, argPos, argWidth) {
    var wBaseL = 0;
    if (argDispOrHtml == "HTML") {
      wBaseL = window.screenX || window.screenLeft;
      if (!wBaseL) {
        wBaseL = 0;
      }
    }
    var wW =
      argDispOrHtml == "HTML"
        ? document.documentElement.clientWidth
        : screen.availWidth;
    if (!wW) {
      wW = 0;
    }
    var wLeft = 0;
    switch (argPos) {
      case "CC":
        wLeft = Math.floor((wW - argWidth) / 2) + wBaseL;
        break;
      case "LT":
        wLeft = wBaseL;
        break;
      case "RT":
        wLeft = Math.floor(wW - argWidth) + wBaseL;
        break;
      case "RB":
        wLeft = Math.floor(wW - argWidth) + wBaseL;
        break;
      case "LB":
        wLeft = wBaseL;
        break;
    }
    if (wLeft < 0) {
      return 0;
    } else {
      return wLeft;
    }
  }
};
